(function($, window, document, s, undefined) {

  /**
  */
  var initOffCanvasSearch = function initOffCanvasSearch() {
    $('.subnav .search').on('click', function toggleOffCanvasSearch(e){
      var $offCanvas = $('.off-canvas.search');

      $offCanvas.toggleClass('open');

      $('.top-wrapper').toggleClass('search-off-canvas-open');

      if ($offCanvas.hasClass('open')) {
        $('#search-input').focus();
      }
    });
  };

  /**
  * Closes all open canvases and is made available for calling by everywhere.
  */
  s.closeOffCanvases = function closeOffCanvases() {
    $('.off-canvas').removeClass('open');
    $('.top-wrapper').removeClass('search-off-canvas-open');

  };


  /**
  * Attach click listener for close buttons of off-canvas divs.
  */
  var initOffCanvasCloseButton = function initOffCanvasCloseButton() {
    s.$body.on('click', '.off-canvas .close-btn', function(){
      $(this).closest('.off-canvas').removeClass('open');
      $('.top-wrapper').removeClass($(this).data('top-wrapper-open-class'));
    });
  };


  s.callOnReady(initOffCanvasSearch);
  s.callOnReady(initOffCanvasCloseButton);

})(jQuery, this, this.document, window.s);
